
<template>
  <div class="products-list">
    <div class="order-thead text-c666 mt-12 clearfix">
      <div class="fl">
        {{ TLang("商品信息", "orderConfirm") }}
      </div>
      <div class="fl">
        {{ TLang("单价", "orderConfirm") }}{{getCurrentUnionName(union_name)}}
      </div>
      <div class="fl">
        {{ TLang("数量", "orderConfirm") }}
      </div>
      <div class="fr">
        {{ TLang("金额", "orderConfirm") }}{{getCurrentUnionName(union_name)}}
      </div>
    </div>
    <div class="order-tbody">
      <!-- 遍历商品订单 -->
      <!-- 遍历商品 productList 多个仓库的多个商品列表 -->
      <div
        v-for="(item, index) in productList"
        :key="item.id"
      >
        <div
          class="order-tbody-item clearfix"
          style="width: 100%;"
        >
          <div class="fl">
            <div class="product-img mr-12 fl">
              <img
              :src="item.imgGuide"
              alt="product img"
            />
            <!-- 爆炸贴图片 -->
            <Sticker :imgList="item.stickerImgList" />
            </div>
            <div
              class="fl"
              style="max-width: 410px;"
            >
              <div
                class="text-c111 line-clamp-1"
                style="max-width: 410px;"
              >
                <i
                  :style="{ fontStyle: 'normal'}"
                >
                  <SingleTag :show="item.giftType == 4" :datas="{name: TLang('奖品', 'list')}" :putName="'PrizeGoods'" />
                </i>
                <i
                  v-for="(tag, index) in item.tags"
                  :key="index"
                  :style="{ fontStyle: 'normal'}"
                >
                  <SingleTag :show="tag.mktFrontType === 9005" :datas="tag" />
                </i>
                {{ item.name }}
              </div>
              <div class="text-c999 mt-8">
                {{ TLang('规格','my') }}：{{ item.specValue1 }}{{ item.specValue2 }}
              </div>
              <div class="text-c999 mt-8 nowrap colorR" v-if="item.discountInfo && item.discountInfo.totalLimit != null">
                {{ disCountDesc(item) }}
              </div>
              <div class="text-c999 mt-8 clearfix birthdayAnnex" v-if="item.birthdayAnnex">
                {{ TLang('配件','my') }}：{{ item.birthdayAnnex }}
              </div>
              <div class="text-c999 mt-8 clearfix newBirthdayCardWrap" v-if="item.birthdaySuitTiles">
              <!-- <div class="text-c999 mt-8 newBirthdayCardWrap"> -->
                <div
                  class="clearfix newBirthdayCard"
                  @click="showDialog(item)"
                >
                  <span class="fl">生日字牌</span>
                  <span
                    class="fr"
                    style="padding-right: 16px; color: #333;"
                  >{{ getSessionTextInfo(item) || TLang('选择', 'address') }}</span>
                </div>
              </div>
              <div
                v-if="item.preSell"
                class="mt-20"
              >
                <img
                  v-if="CookiesOne && CookiesOne == 'en-US'"
                  :src="require('@assets/images/order/pre-sell-en.png')"
                  alt=""
                >
                <img
                  v-else
                  :src="require('@assets/images/order/pre-sell-ch.png')"
                  alt="pre sell"
                />
                <span><em class="font-num">{{ item.presellDate }}</em>
                  {{ ReplaceText(
                    "sss",
                    transformDate(item.deliveryStartStr),
                    ReplaceText(
                      "eee",
                      transformDate(item.deliveryEndStr),
                      TLang("presaleOrder", "orderConfirm")
                    )
                  ) }}
                </span>
              </div>
              <!-- 营销工具 等待订单接口 -->
              <!-- "mktFrontType":"前台促销类型，1001：单一特价，1002：单一折扣，1003：单一直降，1004：抢购", -->
              <!-- <div
                class="mt-20 market-tag"
              >
                <img
                  src="https://image.dongfangfuli.com/worksheet/file/20200917/20200917151209745822517.png"
                  alt="pre sell"
                />
              </div> -->
            </div>
          </div>
          <div class="text-num fl">
            <span v-if="fppConfigure && fppConfigure.groupItem==='Y'">
              <FppGoodsPrice 
                :type="fppConfigure.groupItemClassStyle"
                :price="item.orderPromotionItemList && item.orderPromotionItemList[0] && item.orderPromotionItemList[0].conditionValue"
                :limitPrice="item.orderPromotionItemList[0].priceLimit"
                :unionIcon="unionIcon"
                :showSymbolIcon="fppConfigure.groupItemShowRmbSymbol"
                fontType="orderConfirm"
                :showDecimal="true"
              />
            </span>
            <span v-else>
              {{ item.price }}
            </span>
          </div>
          <div class="text-num fl">
            {{ item.num }}
          </div>
          <div class="text-num fr">
            {{ fppConfigure && fppConfigure.groupItem==='Y'?getFppTotalAmount(item): item.totalPrice }}
          </div>
        </div>
        <div
          v-if="index < productList.length - 1"
          class="line mt-16 mb-16"
        ></div>
      </div>
    </div>
    <el-dialog
      title="生日字牌"
      :visible.sync="centerDialogVisible"
      width="580"
      center
      :before-close="clearAll"
      custom-class="birthdayTextModal"
    >
      <div
        class="partsTextWrap"
        v-if="currentItem && currentItem.birthdaySuitTiles && currentItem.birthdaySuitTiles.text && currentItem.birthdaySuitTiles.text.length > 0"
      >
        <span
          v-for="(partsInfo, partsInfoIndex) in currentItem.birthdaySuitTiles.text"
          :key="partsInfoIndex"
          class="textShow"
          :class="currentText === partsInfo && currentTextType == 1 ? 'active': ''"
          @click="clickTextItem(partsInfo, 1)"
        >{{ partsInfo }}</span>
        <span
          class="textShow"
          :class="currentText == '自定义' || currentTextType == 2 ? 'active': ''"
          @click="clickTextItem('自定义', 2)"
          v-if="currentItem.birthdaySuitTiles.birthdaySuitTilesFlag"
        >自定义</span>
      </div>
      <div class="partsTextWrap" v-else-if="currentItem && currentItem.birthdaySuitTiles && currentItem.birthdaySuitTiles.birthdaySuitTilesFlag">
        <span
          class="textShow"
          :class="currentTextType == 2 ? 'active': ''"
          @click="clickTextItem('自定义', 2)"
        >自定义</span>
      </div>
      <div v-if="currentTextType == 2">
        <!-- <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入自定义祝福,最多14个中文字或28个英文字母"
          :maxlength="28"
          v-model="curTextarea">
        </el-input> -->
        <el-input
          class="partsIpt"
          v-model="curTextarea"
          placeholder="请输入自定义祝福，最多14个中文字或28个英文字母"
          maxlength="28"
          @input="setAccessoryUserRemark"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          class="saveTextBtn"
          @click="saveBirthdayText()"
        >保存</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sticker from '@components/sticker';
import SingleTag from '@components/singleTag';
import Toast from '@components/simpleToast';
import FppGoodsPrice from '@components/FppGoodsPrice';
import { mapState } from 'vuex';
import Cookies from 'js-cookie';
export default {
  name: 'ProductsList',
  components: {
    Sticker,
    SingleTag,
    FppGoodsPrice,
  },
  props: {
    productList: Array,
    warehouseIndex: Number,
    warehouseId: Number || String,
    warehouseNo: String,
    deliveryWay: Object,
    fppConfigure: Object,
    unionIcon: String,
  },
  computed: {
    ...mapState('orderConfirm', ['union_name']),
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
      centerDialogVisible: false,
      currentItem: null,
      currentText: '',
      currentTextType: 0,
      currentSubmitText: '',
      curTextarea: '',
      birthdayInfoList: [],
    };
  },

  methods:{
    // 获取当前单位字符
    getCurrentUnionName(union_name){
      if(this.fppConfigure && this.fppConfigure.groupItem === 'Y'){
        if(this.fppConfigure.groupItemShowRmbSymbol === 'Y'){
          return '(元)';
        } else {
          return '';
        }
      } else {
        return `(${union_name})`;
      }
    },
    // 获取福拼拼显示金额
    getFppTotalAmount(item){
      let price = 0;
      if(item && item.orderPromotionItemList && item.orderPromotionItemList[0] && item.orderPromotionItemList[0].conditionValue){
        price = item.orderPromotionItemList[0].conditionValue;
      }
      const totalPrice = (Number(item.num || 0) * Number(price)).toFixed(
        2,
      );
      return totalPrice;
    },
    setAccessoryUserRemark(value) {
      // let name = '';
      let strLen = 0;

      // 替换 html 代码
      this.curTextarea = value.replace(/<.*>/g, '');

      // 替换是否存在表情
      this.curTextarea = this.curTextarea.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');

      // 多个空格替换为一个空格
      this.curTextarea = this.curTextarea.replace(/\s+/g, ' ');
      this.curTextarea = this.curTextarea.replace(/\(+/g, '（');
      this.curTextarea = this.curTextarea.replace(/\)+/g, '）');

      const regEn = /[`~@#$%^&*()_+<>?:"{},./;'[]]/g;
      const regCn = /[·#￥（——）：；“”‘、|《》？、【】[]]/g;

      this.curTextarea = this.curTextarea.replace(regEn, '');
      this.curTextarea = this.curTextarea.replace(regCn, '');
      //只能输入，。！？（）英文字母/数组/中文
      this.curTextarea = this.curTextarea.replace(/[^，。！？（）,.?!()a-zA-Z0-9\u4e00-\u9fa5]/g,'');
      
      for (let i = 0; i < this.curTextarea.length; i++) {
        if (this.curTextarea.charCodeAt(i) < 27 || this.curTextarea.charCodeAt(i) > 126) {
          strLen += 2;
        } else {
          strLen++;
        }
        if (strLen > 28) {
          this.curTextarea = this.curTextarea.substring(0, i);
          Toast.info('最多14个中文字或28个英文字母');
          return;
        }
        // this.warnTextShow = strLen >= 28;
      }
      // if(this.curTextarea){
      //   this.$emit('setAccessory','('+ this.curTextarea +')');
      // }
    },
    showDialog(item) {
      this.currentItem = item;
      let str = this.getSessionTextInfo(item);
      if (str) {
        if (item.birthdaySuitTiles && item.birthdaySuitTiles.text && item.birthdaySuitTiles.text.length > 0) {
          if (item.birthdaySuitTiles.text.includes(str)) {
            this.currentText = str;
            this.currentTextType = 1;
          } else {
            this.currentText = '自定义';
            this.currentTextType = 2;
            this.curTextarea = str;
          }
        } else {
          this.currentText = '自定义';
          this.currentTextType = 2;
          this.curTextarea = str;
        }
      }
      this.centerDialogVisible = true;
    },
    clearAll() {
      this.centerDialogVisible = false;
      this.currentItem = null;
      this.currentText = '';
      this.currentTextType = 1;
      this.currentSubmitText = '';
      this.curTextarea = '';
    },
    disCountDesc(good){
      const discountInfo = good.discountInfo || {};
      if(discountInfo.totalLimit != null){
        // 剩余可购买数
        const canBuyNum = (discountInfo.totalLimit || 0) - (discountInfo.saleNum || 0);
        if(canBuyNum <= 0){
          return this.TLang('此商品专享价可购剩余数为将以非专享价进行结算','list');
        }
        if(good.num > canBuyNum){
          return `${this.TLang('此商品购买数量超过专享价可购数','list')} ${canBuyNum}，${this.TLang('将以非专享价进行结算','list')}`;
        }
        return '';
      }
      return '';
    },
    transformDate(time){
      const df_lang = Cookies.get('df_lang');
      let timeStr = '';
      if (time) {
        if (df_lang && df_lang == 'en-US' || window.union_isBilingual) {
          timeStr = time.replace(/\d{4}-/, '');
        } else {
          timeStr = time.replace(/\d{4}-/, '').replace(/-/, '月').replace(/\s/, '日');
        }
        return timeStr;
      }
    },
    // 从session缓存中获取每个商品对应的生日牌
    getSessionTextInfo(item) {
      let infoStr = '';
      const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
      if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
        sessionBirthdayInfoList.forEach(a => {
          a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
            if (b.categoryId == item.categoryId && b.goodsId == item.goodsId) {
              infoStr = b.birthdayRemark;
              return infoStr;
            }
          });
        });
      }
      return infoStr;
    },
    // 点击生日字牌 type 1、接口字段 2、自定义
    clickTextItem(text, type){
      this.currentText = text;
      this.currentTextType = type;
    },
    saveBirthdayText(){
      // 先处理生日字牌
      if (this.currentTextType == 2 || this.currentText == '自定义') {
        if (!this.curTextarea) {
          Toast.info('请输入自定义祝福');
          return;
        } else {
          this.currentSubmitText = this.curTextarea;
        }
      } else {
        this.currentSubmitText = this.currentText;
      }

      // 再处理缓存
      const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
      if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
        // 查询缓存，若缓存中有当前商品，则替换，若无，则塞进当前商品
        if (this.checkIn(this.currentItem)) {
          let newArr = JSON.parse(JSON.stringify(sessionBirthdayInfoList));
          newArr.forEach(a => {
            a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
              if (b.categoryId == this.currentItem.categoryId && b.goodsId == this.currentItem.goodsId) {
                b.birthdayRemark = this.currentSubmitText;
              }
            });
          });
          const birInfoList = newArr.filter((item) => item.warehouseId == this.warehouseId && item.index == this.warehouseIndex);
          this.$emit('onResetDeliveryWay', {
            ...this.$props.deliveryWay,
            birthdayInfoList: birInfoList,
          });
          sessionStorage.setItem('birthdayInfoList', JSON.stringify(newArr));
        } else if (this.checkWarehouseIn()) {
          let newArr = JSON.parse(JSON.stringify(sessionBirthdayInfoList));
          newArr.forEach(a => {
            if( a.index == this.warehouseIndex && a.warehouseId == this.warehouseId) {
              a.goodsList.push({
                goodsId: this.currentItem.goodsId,
                categoryId: this.currentItem.categoryId,
                birthdayRemark: this.currentSubmitText,
              });
            }
          });
          const birInfoList = newArr.filter((item) => item.warehouseId == this.warehouseId && item.index == this.warehouseIndex);
          this.$emit('onResetDeliveryWay', {
            ...this.$props.deliveryWay,
            birthdayInfoList: birInfoList,
          });
          sessionStorage.setItem('birthdayInfoList', JSON.stringify(newArr));
        } else {
          let newArr = JSON.parse(JSON.stringify(sessionBirthdayInfoList));
          // 塞进缓存
          let newJson = {
            goodsList: [{
              goodsId: this.currentItem.goodsId,
              categoryId: this.currentItem.categoryId,
              birthdayRemark: this.currentSubmitText,
            }],
            index: this.warehouseIndex,
            warehouseId: this.warehouseId,
            warehouseNo: this.warehouseNo,
          };
          newArr.push(newJson);
          const birInfoList = newArr.filter((item) => item.warehouseId == this.warehouseId && item.index == this.warehouseIndex);
          this.$emit('onResetDeliveryWay', {
            ...this.$props.deliveryWay,
            birthdayInfoList: birInfoList,
          });
          sessionStorage.setItem('birthdayInfoList', JSON.stringify(newArr));
        }
      } else {
        // 塞进缓存
        let newJson = {
          goodsList: [{
            goodsId: this.currentItem.goodsId,
            categoryId: this.currentItem.categoryId,
            birthdayRemark: this.currentSubmitText,
          }],
          index: this.warehouseIndex,
          warehouseId: this.warehouseId,
          warehouseNo: this.warehouseNo,
        };
        let newArr = [];
        newArr.push(newJson);
        const birInfoList = newArr.filter((item) => item.warehouseId == this.warehouseId && item.index == this.warehouseIndex);
        this.$emit('onResetDeliveryWay', {
          ...this.$props.deliveryWay,
          birthdayInfoList: birInfoList,
        });
        sessionStorage.setItem('birthdayInfoList', JSON.stringify(newArr));
      }
      this.clearAll();
    },
    // 判断是否包含该商品
    checkIn(item){
      let flag = false;
      const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
      if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
        sessionBirthdayInfoList.forEach(a => {
          a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
            if (b.categoryId == item.categoryId && b.goodsId == item.goodsId) {
              flag = true;
              return flag;
            }
          });
        });
      }
      return flag;
    },
    // 判断是否含有同仓库
    checkWarehouseIn(){
      let flag = false;
      const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
      if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
        sessionBirthdayInfoList.forEach(a => {
          if( a.index == this.warehouseIndex && a.warehouseId == this.warehouseId) {
            flag = true;
            return flag;
          }
        });
      }
      return flag;
    },
  },
};
</script>

<style lang="less" scoped>
.order-tbody {
  padding: 16px 24px;
  .product-img {
    width: 90px;
    height: 90px;
    border: solid 1px #e5e5e5;
    box-sizing: border-box;
    position: relative;
    img{
      width: 90px;
      height: 90px;
    }
  }
  /deep/.sticker-wrap img{
  height: 90px !important;
}
/deep/.common-font-style{
  font-size: 16px;
}
}

.order-thead,
.order-tbody .order-tbody-item {
  & > :nth-of-type(1) {
    width: 46.17%;
  }
  & > :nth-of-type(2) {
    width: 23.75%;
  }
  & > :nth-of-type(3) {
    width: 18%;
  }
  & > :nth-of-type(4) {
    width: 123px;
    text-align: right;
  }
  .nowrap{
    white-space: nowrap;
  }
  .colorR{
    color: #F75E35;
  }
  .birthdayAnnex {
    max-width: 420px;
    word-wrap:break-word;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
.newBirthdayCardWrap {
  width: 420px;
  height: 27px;
  background: #F7F7F7;
  border-radius: 2px;
  line-height: 27px;
  padding: 0 10px;
  box-sizing: border-box;
  color: #666;
  cursor: pointer;
  .newBirthdayCard {
    width: 100%;
    background: url("~@assets/images/order/parts/moreCardText.png") right center no-repeat;
    background-size: 16px 16px;
  }
}
.birthdayTextModal {
  /deep/ .el-dialog__header {
    padding: 16px 20px !important;
  }
}
.partsTextWrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .textShow {
    display: block;
    max-width: 100%;
    box-sizing: border-box;
    padding: 8px 12px 8px 15px ;
    font-size: 14px;
    color: #333;
    line-height: 19px;
    margin: 0 16px 16px 0;
    border-radius: 2px;
    border: 1px solid #B2B2B2;
    cursor: pointer;
  }
  .active {
    color: #3D96E2;
    border: 1px solid #3D96E2;
  }
}
.partsIpt {
  /deep/.el-input__inner{
    background: #F7F7F7;
    border-radius: 2px;
    border: none;
    height: 44px;
    line-height: 44px;
    padding: 0 10px;
    font-size: 14px;
  
    color: #333;
  }
}

.saveTextBtn {
  display: inline-block;
  margin: 0 auto;
  background: linear-gradient(315deg, #5CB4EC 0%, #3D96E2 100%);
  border-radius: 4px;
  cursor: pointer;
  padding: 16px 59px;
  text-align: center;
  font-size: 16px;
  line-height: 21px;
  color: #fff;
  margin-bottom: 4px;
}
</style>
